import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {ServiceSubject} from '../Models/ServiceSubject';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ServiceSubjectItemService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getServiceSubjectItem(id = null) {
    return this.http.get<ServiceSubject>(environment.apiUrl + '/backoffice/service-subject-item/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/service-subject-item/' + id + '/change-position', {position: position})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public deleteServiceSubjectItem(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/service-subject-item/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAddServiceSubjectItem(id) {
    return this.http.put(environment.apiUrl + '/backoffice/service-subject-item/' + id + '/readd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageServiceSubjectItem(serviceSubject, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/service-subject-item/' + id, serviceSubject)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/service-subject-item/ ', serviceSubject)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
